import { pathOr } from 'ramda'
import { PureComponent } from 'react'

import MessageInput from '@/app/component/send/message'
import { CAMPAIGN_CHANGE_DELAY } from '@/app/module/campaigns/definitions'
import { LanguageType } from '@/app/module/campaigns/helpers'
import { CATIMessage, CATIQuestion, PartFamily, SMSMessage, SMSQuestion } from '@/app/module/campaigns/types'
import { PersonalizationType } from '@/app/types'

import LanguageWrapper from './language-wrapper'
import { getSMSLanguageMap } from './types/multimessage/content'

type Message = CATIMessage | CATIQuestion | SMSMessage | SMSQuestion

type Props<T extends Message> = {
  defaultLanguage: string
  info: string
  item: T
  label?: string
  languages: LanguageType[]
  personalizationList: PersonalizationType

  changeHandler: (item: Partial<T>, changed?: boolean) => void
}

type State = {
  error: string
  text: string
  timeout: any
}

export default class CampaignContentSMS<T extends Message> extends PureComponent<Props<T>, State> {
  state = {
    timeout: null,
    text: pathOr('', ['item', 'message', 'text'], this.props),
    error: '',
  }

  item: Partial<T> | null = null

  componentWillUnmount() {
    const { timeout } = this.state
    if (timeout) {
      clearTimeout(timeout)
    }
    if (this.item) {
      this.props.changeHandler(this.item)
    }
  }

  changeHandler = (item: Partial<T> = {}) => {
    const { changeHandler } = this.props

    if (this.state.timeout) {
      clearTimeout(this.state.timeout)
    }

    this.item = item
    this.setState({
      error: this.state.text ? '' : this.state.error,
      timeout: setTimeout(() => {
        changeHandler(item)
        this.item = null
        this.setState((state) => ({
          timeout: clearTimeout(state.timeout),
        }))
      }, CAMPAIGN_CHANGE_DELAY),
    })
  }

  render() {
    const { item, label, personalizationList, info, languages, defaultLanguage } = this.props

    return (
      <div>
        <div>
          <div className="campaign-item-content">
            <LanguageWrapper
              content="text"
              defaultLanguage={defaultLanguage}
              info={info}
              item={item}
              languageContentMap={getSMSLanguageMap(item.message, defaultLanguage)}
              languages={languages}
              type="message"
              onChange={this.changeHandler}
            >
              {(text: string, onTextChange: (payload: { message: string }) => void, error: string) => (
                <MessageInput
                  autoFocus={item.autoFocus}
                  hideInfo={item.type === PartFamily.CATI} // hide sms chars count
                  label={label}
                  message={text}
                  error={error || this.state.error}
                  personalizationList={personalizationList}
                  onChange={onTextChange}
                />
              )}
            </LanguageWrapper>
          </div>
        </div>
      </div>
    )
  }
}
